export enum TypeContratoServico {
  PARCERIA_COMERCIAL_CEO_GESTOR = 'PARCERIA_COMERCIAL_CEO_GESTOR',
  PARCERIA_COMERCIAL_CEO_COMERCIAL = 'PARCERIA_COMERCIAL_CEO_COMERCIAL',
  PARCERIA_GESTOR_COMERCIAL = 'PARCERIA_GESTOR_COMERCIAL'
}

export const DEFAULT_USER_PARTNERSHIP_CONTRACT = TypeContratoServico.PARCERIA_COMERCIAL_CEO_COMERCIAL
